/* eslint-disable @typescript-eslint/no-explicit-any */
import Script from "next/script";
import { FC } from "react";
import { useChatbotContext } from "~/hooks/chatbot/useChatbotContext";
import { useChatbotTracking } from "~/hooks/chatbot/useChatbotTracking";

const Chatbot: FC = () => {
  const { chatbotProps } = useChatbotContext();

  const visible = chatbotProps?.visible ?? false;
  const currentPage = chatbotProps?.currentPage ?? "";
  const sdkVersion = chatbotProps?.sdkVersion ?? "";

  useChatbotTracking({ visible, currentPage });

  // Don't render if chatbot is disabled or loading
  if (!chatbotProps) return null;

  const chatbotFolder = "https://d2w3zkq33l1i26.cloudfront.net/chatbot";

  return (
    <>
      <link rel={"stylesheet"} href={`${chatbotFolder}/${sdkVersion}/kore-chatbot-v2-fuel.min.css`} />
      <Script
        strategy="lazyOnload"
        src={`${chatbotFolder}/${sdkVersion}/kore-chatbot-v2-fuel.min.js`}
        onLoad={() => {
          let attempts = 0;
          const timer = setInterval(() => {
            const koreChatWindow = document.querySelector('[id*="kore-chat-window"]');
            if (koreChatWindow) {
              const minimizeEl = koreChatWindow.querySelector(".minimized");
              if (minimizeEl && minimizeEl instanceof HTMLElement) {
                minimizeEl.style.setProperty("width", "0px", "important");
              }
            }
            attempts += 1;
            if (attempts >= 8) clearInterval(timer);
          }, 500);
        }}
      />
    </>
  );
};

Chatbot.displayName = "Chatbot";

export default Chatbot;
